import { useQuery } from "@tanstack/react-query";
import { api } from "./api";

export const DEFAULT_SETTINGS = {
  address: "Via Tuscolana Vecchia, 99",
  city: "Frascati (RM)",
  phone: "393 510 4463",
  whatsapp: "393935104463",
  hours: "Martedì – Sabato: 9:30 – 18:30\nDomenica e Lunedì: chiuso",
  location_notes: "",
  instagram: "https://www.instagram.com/aura_microblading_nails_tech?mdxt=NHA1bmdhejMyMXMw&utm_source=qr",
  facebook: "",
  tiktok: "",
};

export function useSettings() {
  const { data } = useQuery({
    queryKey: ["settings"],
    queryFn: async () => (await api.get("/settings")).data,
  });
  return { ...DEFAULT_SETTINGS, ...(data && typeof data === "object" ? data : {}) };
}

export const waLink = (s, text = "Ciao AURA! Vorrei informazioni / prenotare un appuntamento.") =>
  `https://wa.me/${s.whatsapp}?text=${encodeURIComponent(text)}`;

export const fullAddress = (s) => [s.address, s.city].filter(Boolean).join(", ");
export const MAP_COORDS = "41.822087,12.639322";
export const MAP_LINK = "https://maps.app.goo.gl/bitqTTMFpet3Merr5";

let lenisInstance = null;
export const setLenis = (l) => { lenisInstance = l; };
export function scrollToId(id) {
  const el = document.getElementById(id);
  if (!el) return;
  if (lenisInstance) lenisInstance.scrollTo(el, { offset: -72, duration: 1.4 });
  else el.scrollIntoView({ behavior: "smooth" });
}

export const openChat = () => window.dispatchEvent(new Event("aura:open-chat"));

export const EASE = [0.22, 1, 0.36, 1];
